import React from "react";

const DebtDisclosure = ({ agencyDetails }) => {
  if (!agencyDetails?.name) {
    return null;
  }

  return (
    <div className="mt-4 text-center text-xs text-white/40 max-w-3xl mx-auto px-4">
      This is a communication from {agencyDetails.name}, a debt collector. This
      is an attempt to collect a debt and any information obtained will be used
      for that purpose. Calls to and from {agencyDetails.name} are recorded and
      may be monitored.
    </div>
  );
};

export default DebtDisclosure;
